import { HostBinding, Directive, Input } from "@angular/core";
import * as ɵngcc0 from '@angular/core';
var SuiTabContent = /** @class */ (function () {
    function SuiTabContent() {
        this.isActive = false;
        this._contentClasses = true;
    }
    /** @nocollapse */
    SuiTabContent.ctorParameters = function () { return []; };
    SuiTabContent.propDecorators = {
        "_contentClasses": [{ type: HostBinding, args: ["class.tab",] },],
        "id": [{ type: Input, args: ["suiTabContent",] },],
        "isActive": [{ type: HostBinding, args: ["class.active",] },],
    };
SuiTabContent.ɵfac = function SuiTabContent_Factory(t) { return new (t || SuiTabContent)(); };
SuiTabContent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SuiTabContent, selectors: [["", "suiTabContent", ""]], hostVars: 4, hostBindings: function SuiTabContent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", ctx.isActive)("tab", ctx._contentClasses);
    } }, inputs: { id: ["suiTabContent", "id"] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiTabContent, [{
        type: Directive,
        args: [{
                selector: "[suiTabContent]"
            }]
    }], function () { return []; }, { isActive: [{
            type: HostBinding,
            args: ["class.active"]
        }], _contentClasses: [{
            type: HostBinding,
            args: ["class.tab"]
        }], id: [{
            type: Input,
            args: ["suiTabContent"]
        }] }); })();
    return SuiTabContent;
}());
export { SuiTabContent };

